import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../../../helpers/export'
import IndustryScaleService from './service'

export const getIndustryScaleTable = createAsyncThunk(
  'companyAnalysis/industryOverview/industryScale/getIndustryScaleTable',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const res = await IndustryScaleService.getIndustryScaleTable(params)

      if (res.success) {
        dispatch(
          calculateDefaultUnit({
            screen: SCREEN.INDUSTRY_OVERVIEW,
            getValues: () =>
              res.data
                .map((item) => [
                  { value: item.scaleData.industryNetRevenue, year: item.year },
                  {
                    value: item.scaleData.industryTotalAssets,
                    year: item.year,
                  },
                ])
                .flat(),
          }),
        )

        return res.data
      }

      return rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadIndustryScale = createAsyncThunk(
  'companyAnalysis//industryOverview/industryScale/downloadScale',
  async (params) => {
    try {
      const res = await IndustryScaleService.downloadIndustryScale(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
